import type { CSSProperties } from 'react';
import type { AppMeta } from './useAppMeta';

const containerStyle: CSSProperties = {
  minHeight: '100dvh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.2rem',
  fontFamily: 'system-ui, sans-serif',
  color: '#111',
  background: '#fafafa',
};

const nameStyle: CSSProperties = {
  margin: 0,
  fontSize: '1.1rem',
  opacity: 0.85,
};

const dotStyle: CSSProperties = {
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '50%',
  background: '#999',
  animation: 'hook-pulse 1.2s ease-in-out infinite',
};

export interface AppLoadingSkeletonProps {
  meta?: AppMeta;
}

export function AppLoadingSkeleton({ meta }: AppLoadingSkeletonProps) {
  const logoSrc = meta?.logo_url ?? '/hook-logo.svg';
  const alt = meta?.name ?? 'Hook';
  return (
    <div style={containerStyle}>
      <style>{`@keyframes hook-pulse { 0%,100% { opacity: 0.3 } 50% { opacity: 1 } }`}</style>
      <img src={logoSrc} alt={alt} width={64} height={64} />
      {meta?.name && <h1 style={nameStyle}>{meta.name}</h1>}
      <div style={dotStyle} />
    </div>
  );
}
